import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { capitalizeName } from "../../../../shared/utils/util";
import "./Sharer.scss";

export interface SharerProps {
	sharer: { id: string; name: string; surname: string };
}

const Sharer: React.FC<SharerProps> = ({ sharer }) => {
	const navigate = useNavigate();
	const clickUser = () => {
		navigate(`/u/${sharer.id}`);
	};
	const [imageUrl, setImageUrl] = useState();

	return (
		<div className="sharer">
			<div
				className="caption"
				onClick={clickUser}
			>
				<img
					className="profile-pic"
					src={""}
				></img>
				<p className="username">{capitalizeName(sharer.name)} {capitalizeName(sharer.surname)} </p>
				<p>shared a post</p>
			</div>

			<div className="divider"></div>
		</div>
	);
};

export default Sharer;
